import { DEFAULT_COUNTRY_ID, DEFAULT_COUNTRY_NAME } from '@model/Country';
import { Moment } from 'moment';
import * as Yup from 'yup';
import { Model, ModelClass } from './Model';

export interface LocationType extends ModelClass {
    id: number;
    country: any;

    country_name: string;
    country_id: number;

    city_name: string;
    city_id: number;

    state: string;
    longitude: number;
    latitude: number;
    name: string;
    company: string;
    street: string;
    zip: string;
    full_address: string;
    flat: any;
    address_1: string;
    address_2: string;
    distance: string;
    fei_number: string;
    created_at: Moment;
    updated_at: Moment;
}

export const Location = Model<LocationType>('Location', { endpoint: 'locations' })`
    id:Int;
    created_at:DateTime;
    updated_at:DateTime;
    country_id:Int;
    country:Any;
    country_name: String;
    city_name:String;
    state:String;
    name:String;
    company: String;
    street:String;
    address_1:String;
    address_2:String;
    zip:String;
    flat:String;
    full_address:String;
    fei_number:String;
`;

export const LocationValidation: any = Yup.object().shape({
    name: Yup.string().trim().required('Address title is required'),
    address_1: Yup.string().trim().required('Address Line 1 is required'),
    address_2: Yup.string().nullable(),
    city_name: Yup.string().trim().required('City is required'),
    state: Yup.string().trim().required('State is required'),
    country_id: Yup.string().required('Country is required'),
    zip: Yup.string()
        .trim()
        .when('country_id', {
            is: (state) => state === '236' || state === '38',
            then: Yup.string().trim().required('Field is required'),
            otherwise: Yup.string().trim(),
        }),
});

export const CustomerAcounttLocationValidation: any = Yup.object().shape({
    location: Yup.object().shape({
        name: Yup.string().trim().required('Address title is required'),
        address_1: Yup.string().trim().required('Address Line 1 is required'),
        address_2: Yup.string().nullable(),
        city_name: Yup.string().trim().required('City is required'),
        state: Yup.string().trim().required('State is required'),
        country_id: Yup.string().required('Country is required'),
        zip: Yup.string()
            .trim()
            .when('country_id', {
                is: (state) => state === '236' || state === '38',
                then: Yup.string().trim().required('ZIP is required'),
                otherwise: Yup.string().trim(),
            }),
    }),
});

export const getDefaultLocation = (customer?: any) => {
    return {
        name: customer
            ? customer.user
                ? `${customer.user.first_name} ${customer.user.last_name}`
                : customer.organization_name
            : '',
        company: '',
        address_1: '',
        address_2: '',
        zip: '',
        city_name: '',
        state: '',
        fei_number: '',
        country_id: DEFAULT_COUNTRY_ID,
        country_name: DEFAULT_COUNTRY_NAME,
    };
};
